import nprogress from 'nprogress'
import { useEffect } from 'react'

import logo from '@/assets/images/logotipoResumido.png'

import './index.scss'

export const LazyLoad: React.FunctionComponent<{ inside?: boolean }> = ({
  inside,
}) => {
  useEffect(() => {
    nprogress.start()
    return () => {
      nprogress.done()
    }
  })

  return (
    <div className={`lazy-load ${inside ? 'inside' : ''}`}>
      <img alt='logo' src={logo} />
    </div>
  )
}
